<!--
 * @Description: ================== 游戏介绍 =================
 * @Date: 2022-05-13 18:08:07
 * @Author: Zero
 * @FilePath: \guobao-web\src\components\Game.vue
 * @LastEditors: Zero
 * @LastEditTime: 2022-06-14 14:51:49
-->
<template>
  <div class="page page-game">
    <div style="margin-top:20px">
      <img src="/banner.jpg" alt="" style="width: 100%" />
    </div>
    <h2 class="title">游戏介绍</h2>
    <p>宿命轮回再启，柱与弦羁绊重燃！热血交织的《探险终章》斩鬼战场，组建专属巅峰鬼杀队，改写每一段意难平的遗憾剧情，守护心中珍视之人！</p>
    <!-- <pre> -->
    <h2 class="title" style="margin-bottom: 0px">游戏特色</h2>
    <div class="content">
      <div class="content-item">
        <h4>【全呼吸法复刻 沉浸式斩鬼】</h4>
        日轮刀寒光破晓，全呼吸法技能1:1还原！水之呼吸的流畅连击、炎之呼吸的炽热爆破、霞之呼吸的缥缈突袭，360°全景战斗视角搭配原作级剧情音效，每一场对决都燃爆感官！
        <img src="/1.jpg" alt="" />
      </div>
      <div class="content-item">
        <h4>【宿命羁绊养成 解锁隐藏剧情】</h4>
        深度羁绊系统上线！与柱、弦角色并肩作战解锁专属剧情，触发宿命羁绊增益，定制个性化养成路径。从锻刀村的历练到花街的潜伏，每一次选择都可能改写角色命运！
        <img src="/2.jpg" alt="" />
      </div>
      <div class="content-item">
        <h4>【经典战役复刻 跨服共战鬼王】</h4>
        无限城的诡谲、花街的迷影、锻刀村的守护……全经典战役高精度还原！跨服组队实时联机，与全服玩家同屏挥刀，呼吸共鸣叠加战力，以团队之力冲破鬼王诅咒，战至黎明破晓！
        <img src="/3.jpg" alt="" />
      </div>
      <div class="content-item">
        <h4>【零氪狂喜 千抽开局即巅峰】</h4>
        新服豪礼加码！登录即领千抽福利，SSR柱级角色直接入队，无需肝度轻松起号。超高人气社交互动，攻略分享、战队组建一键直达，零氪也能畅享斩鬼快感！
        <img src="/4.jpg" alt="" />
      </div>
    </div>
    <!-- </pre> -->
  </div>
</template>

<style scss>
.content-item {
  display: inline-block;
  width: 50%;
  padding: 12px;
  box-sizing: border-box;
  vertical-align: top;
}
.content-item img {
  display: block;
  margin-top: 12px;
  width: 400px;
}
@media screen and (max-width: 768px) {
  .content-item {
    width: 100%;
  }
  .content-item img {
    width: 100%;
  }
}
</style>
